import { z } from "zod";

export const requestResetCodeSchema = z.object({
  email: z.string().trim().email("Please enter a valid email address"),
});

export const confirmResetPasswordSchema = z
  .object({
    code: z.string().min(6, "Verification code must be at least 6 characters"),
    newPassword: z
      .string()
      .min(8, "Password must be at least 8 characters")
      .max(20, "Password must be at most 20 characters")
      .regex(/[A-Z]/, "Password must contain at least one uppercase letter")
      .regex(/[a-z]/, "Password must contain at least one lowercase letter")
      .regex(/[0-9]/, "Password must contain at least one number")
      .regex(/[^A-Za-z0-9]/, "Password must contain at least one special character"),
    confirmPassword: z.string().min(8).max(20),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: "Passwords don't match",
    path: ["confirmPassword"],
  });

export type RequestResetCodeValues = z.infer<typeof requestResetCodeSchema>;
export type ConfirmResetPasswordValues = z.infer<typeof confirmResetPasswordSchema>;